import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    ExcelService,

    PurchaseReportService
} from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./OrderVsInvoice.html",
})
export class OrderVsInvoiceReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];

  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partyList$ = [];
  dataList: any[];
  exceldata: any;
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "desc",
  };
  filter: any = {};

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    po_no: "",
    inv_no: "",
    fin_id: "",
    party_code: "",
    order_from_date: "",
    order_to_date: "",
    inv_from_date: "",
    inv_to_date: "",
    groupby: "PONO",
    diff: "All",
  };
  difference = ["All", "Difference", "Pending"];
  finyearList = [];
  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Order Against Invoice Report",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purService: PurchaseReportService,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          //this.getOrderVsInvoiceReport();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "Pono",
        prop: "po_no",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "Inv no",
        prop: "invoice_no",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "PO Date",
        prop: "po_date",
        minWidth: 110,
        maxWidth: 110,
        width: 110,
        align: "center",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Date",
        prop: "invoice_date",
        minWidth: 110,
        maxWidth: 110,
        width: 110,
        align: "center",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Invoice Name",
        prop: "party_name",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-left",
      },
      {
        name: "Design",
        prop: "design_no",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "Ordr Width",
        prop: "width",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Width",
        prop: "inv_width",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Ordr Mtrs",
        prop: "mtrs",
        summary: "sum",
        minWidth: 110,
        maxWidth: 110,
        width: 110,
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Mtrs",
        prop: "qty",
        summary: "sum",
        minWidth: 110,
        maxWidth: 110,
        width: 110,
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Ordr Rate",
        prop: "rate",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Rate",
        prop: "inv_rate",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Ordr Amt",
        prop: "amount",
        summary: "sum",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Amt",
        prop: "inv_amt",
        summary: "sum",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.finyearCombo();

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterinvno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    // this.getOrderVsInvoiceReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    //this.getOrderVsInvoiceReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    //this.getOrderVsInvoiceReport();
  }

  onbackbutton(group) {
    this.filterData.groupby = "PONO";
    this.filterData.po_no = "";
    this.getOrderVsInvoiceReport();
  }

  onCellClick(event) {
    this.filterData.po_no = event.row.po_no;
    this.filterData.groupby = "INVOICE";
    this.getOrderVsInvoiceReport();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.fin_id = res.data[0].fin_id;
      that.getOrderVsInvoiceReport();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  getOrderVsInvoiceReport(): void {
    if (this.filterData.order_from_date == "") {
      this.filterData.order_from_date = "";
    } else {
      this.filterData.order_from_date = this.datePipe.transform(
        this.filterData.order_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.order_to_date == "") {
      this.filterData.order_to_date = "";
    } else {
      this.filterData.order_to_date = this.datePipe.transform(
        this.filterData.order_to_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.inv_from_date == "") {
      this.filterData.inv_from_date = "";
    } else {
      this.filterData.inv_from_date = this.datePipe.transform(
        this.filterData.inv_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.inv_to_date == "") {
      this.filterData.inv_to_date = "";
    } else {
      this.filterData.inv_to_date = this.datePipe.transform(
        this.filterData.inv_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_code: this.filterData.party_code,
      inv_no: this.filterData.inv_no,
      po_no: this.filterData.po_no,
      order_from_date: this.filterData.order_from_date,
      order_to_date: this.filterData.order_to_date,
      inv_from_date: this.filterData.inv_from_date,
      inv_to_date: this.filterData.inv_to_date,
      fin_id: this.filterData.fin_id,
      groupby: this.filterData.groupby,
      diff: this.filterData.diff,
    };
    console.log(params);
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.purService
      .getOrderVsInvoiceReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.invoiceData = res.data;

        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false,
        };

        that.printConfig = {
          title: "Order Against Invoice Report",
          columns: res.data.columns,
          rows: that.invoiceData,
        };
        that.exceldata = that.getData(res.data.columns, res.data);
      });
  }

  clearFilter(): void {
    (this.filterData.po_no = ""),
      (this.filterData.inv_no = ""),
      (this.filterData.party_name = ""),
      (this.filterData.order_from_date = ""),
      (this.filterData.order_to_date = ""),
      (this.filterData.inv_from_date = ""),
      (this.filterData.inv_to_date = "");
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderVsInvoiceReport();
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/ordervsinvoice/OrderVsInvoice.ts